<div class="w-100 flex-col" >
  @if(dataSource){
  <!-- phones: scrolls horizontally, unit type column stays visible (see theme/styles/_table-stack.scss) -->
  <div class="table-scroll-sm">
    <table mat-table [dataSource]="dataSource" class="w-100 container">
      <ng-container matColumnDef="unitType" sticky>
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let unitMix; let i = index">Type {{i + 1}}:</td>
      </ng-container>
      <ng-container matColumnDef="bedrooms">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">Beds</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content"> {{unitMix.bedrooms}} </td>
      </ng-container>
      <ng-container matColumnDef="bathroomsFull">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">Baths</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content"> {{unitMix.bathroomsFull}} </td>
      </ng-container>
      <ng-container matColumnDef="bathroomsHalf">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">1/2 Baths</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content"> {{unitMix.bathroomsHalf}} </td>
      </ng-container>
      <ng-container matColumnDef="numberOfUnits">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">No. Units</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content"> {{unitMix.numberOfUnits}} </td>
      </ng-container>
      <ng-container matColumnDef="area">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">SqFt</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content"> {{unitMix.displayArea}} </td>
      </ng-container>
      <ng-container matColumnDef="avgRent">
        <th mat-header-cell *matHeaderCellDef class="center-table-content">Avg Rent</th>
        <td mat-cell *matCellDef="let unitMix" class="center-table-content">@if (unitMix.avgRent) {
          <span>{{unitMix.avgRent | currency : 'USD' : 'symbol' : '1.2'}}</span>
          } @if (!unitMix.avgRent) {
          <span>{{unitMix.displayAvgRent}}</span>
        }</td>
      </ng-container>
  
      <!-- Actions Column -->
      @if (!readOnly()) {
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="text-end"> Actions </th>
          <td mat-cell *matCellDef="let unitMix" class="ws-nowrap text-end">
            <button  mat-icon-button color="primary" (click)="onEditUnitMix(unitMix)" matTooltip="Edit unit mix">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="onDeleteUnitMix(unitMix)" matTooltip="Delete unit mix">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
      }
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let unitMix; columns: displayedColumns;"></tr>
    </table>
  </div>
  }
</div>